import { SAFE_TX_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  monitor: {
    title: "Estado del sistema",
    signer: {
      title: "Firmante",
      address: "Dirección",
      balance: "Balance",
      ok: "Correcto",
      low: "Bajo",
      critical: "Crítico",
      hintOk: "Balance suficiente para operar con normalidad.",
      hintLow: "El balance es bajo. Recarga pronto para seguir firmando transacciones.",
      hintCritical: "Balance crítico. Las transacciones no se podrán firmar si no se recarga.",
    },
    votingSafe: {
      title: "Safe de Votaciones",
    },
    censusSafe: {
      title: "Safe de Censos",
    },
    safe: {
      address: "Dirección",
      threshold: "Firmas necesarias",
      status: "Estado",
      ok: "Sin pendientes",
      pendingCount: "{{count}} pendiente(s)",
      oldestPending: "Más antigua",
      minutes: "min",
      viewInSafe: "Ver en Safe",
    },
  },
  actions: {
    refreshAllowlists: {
      button: "Actualizar censos automáticos",
      success: "Censos actualizados: {{processedCount}} procesados, {{skippedCount}} omitidos, {{errorCount}} errores.",
      error: "Error al actualizar los censos automáticos.",
    },
    executePending: {
      button: "Ejecutar transacciones pendientes",
      success: "Transacciones: {{executed}} ejecutadas, {{failed}} fallidas de {{totalPending}} pendientes.",
      error: "Error al ejecutar las transacciones pendientes.",
    },
  },
  transactions: {
    title: "Transacciones Pendientes",
    votingTitle: "Transacciones Pendientes - Votaciones",
    censusTitle: "Transacciones Pendientes - Censos",
    safeTxHash: "Hash de transacción",
    nonce: "Nonce",
    to: "Destino",
    value: "Valor",
    confirmations: "Confirmaciones",
    submissionDate: "Fecha",
    status: "Estado",
    actions: "Acciones",
    view: "Ver",
    empty: "No hay transacciones pendientes",
    executable: "Ejecutable",
    pending: "Pendiente",
  },
  safeTransactions: {
    votingTitle: "Historial de Transacciones - Votaciones",
    censusTitle: "Historial de Transacciones - Censos",
    sectionTitle: "Historial de Transacciones",
    title: "Título",
    safeTxHash: "Hash de transacción",
    nonce: "Nonce",
    to: "Destino",
    confirmations: "Confirmaciones",
    createdAt: "Fecha",
    status: "Estado",
    actions: "Acciones",
    view: "Ver",
    empty: "No hay transacciones",
    statusValues: {
      [SAFE_TX_STATUS_ENUM.PROPOSED]: "Propuesta",
      [SAFE_TX_STATUS_ENUM.EXECUTED]: "Ejecutada",
      [SAFE_TX_STATUS_ENUM.FAILED]: "Fallida",
    },
  },
}
